export default __webpack_public_path__ + "static/media/inputURATimg.701472ff.png";